// extracted by mini-css-extract-plugin
module.exports = {"title":"BuffInfo_title__3RDez","subtitle":"BuffInfo_subtitle__kQ7PG","item":"BuffInfo_item__2-dHN","itemContent":"BuffInfo_itemContent__3_Ur5","icon":"BuffInfo_icon__18bnQ"};